import { Component, Inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { PredefinedFilter } from 'src/app/models/predefined-filter';
import { DialogSavePredefinedFilterData } from './models/dialog-save-predefined-filter-data';

import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { OnKeyEnterEventDirective } from '../../../core/directives/on-key-enter-event.directive';

@Component({
    selector: 'app-save-predefined-filter',
    templateUrl: './save-predefined-filter.component.html',
    styleUrls: ['./save-predefined-filter.component.scss'],
    imports: [MatCardModule, MatFormFieldModule, MatInputModule, FormsModule, OnKeyEnterEventDirective, ReactiveFormsModule, MatCheckboxModule, MatButtonModule, MatDialogClose]
})
export class SavePredefinedFilterComponent {
    /**
     * Champs du formulaire de saisie de commentaire.
     */
    public nameFormControl = new UntypedFormControl(null, [Validators.required]);
    public sharedFormControl = new UntypedFormControl(null);

    /**
     * Constructeur.
     * @param dialogRef
     * @param predefinedFilter
     */
    constructor(
        public dialogRef: MatDialogRef<SavePredefinedFilterComponent, PredefinedFilter>,
        @Inject(MAT_DIALOG_DATA) public dialogSavePredefinedFilterData: DialogSavePredefinedFilterData
    ) {}

    /**
     * Appelée lorsque l'utilisateur clique sur le bouton 'Annuler'.
     */
    public cancel(): void {
        this.dialogRef.close();
    }

    /**
     * Appelée lorsque l'utilisateur clique sur la touche ENTREE depuis le champ name.
     */
    public validate() {
        if (this.nameFormControl.valid === true) {
            this.dialogRef.close(this.dialogSavePredefinedFilterData.predefinedFilter);
        }
    }
}
